import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import DocumentImage from "views/admin/images";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// ...autres imports

import Dashboard from "views/admin/Dashboard.js";
import Settings from "views/admin/Settings.js";
import ImageUpload from "views/admin/Tables.js";
import Logout from "views/admin/Maps.js";
import ValidatedList from "views/admin/ValidatedList";
import RefusedList from "views/admin/RefusedList";
import AnnulerDemandes from "views/admin/demandeAnnulation";
import ListeTemoignages from "views/admin/temoignages";
import UserCreate from "Banque/Admin/userCreate";
import AdminCredit from "Banque/Admin/virement";
import AccountsDirectory from "Banque/Admin/allusers";
import AdminTransferts from "Banque/Admin/ValidateTransferts";
import ValidatedVirements from "Banque/Admin/ValidatedVirements";
import RefusedVirements from "Banque/Admin/RefusedVirements";
import PhysicalCardRequests from "Banque/Admin/PhysicalCardRequests";
import EnvoiEmail from "views/admin/EnvoiEmail";


export default function Admin() {
  // 1. State du thème
  const [themeKey, setThemeKey] = useState(
    localStorage.getItem("adminTheme") || "light"
  );

  // 2. Sauvegarde dans localStorage
  useEffect(() => {
    localStorage.setItem("adminTheme", themeKey);
    // 3. Optionnel : applique le fond à tout le dashboard
    document.body.style.background = themeKey === "dark" ? "#191b24" : "#f6f8fa";
    document.body.style.color = themeKey === "dark" ? "#f3f4f6" : "#23253a";
  }, [themeKey]);

  // 4. Handler pour changer de thème
  const handleToggleTheme = () => setThemeKey(t => (t === "light" ? "dark" : "light"));

  return (
    <>
      <Sidebar themeKey={themeKey} onToggleTheme={handleToggleTheme} />
      <div
        className="relative md:ml-64"
        style={{
          background: themeKey === "dark" ? "#191b24" : "#f6f8fa",
          minHeight: "100vh"
        }}
      >
        <div className="px-4 md:px-10 mx-auto w-full mt-6">
          <Switch>
            <Route path="/admin/" exact component={Dashboard} />
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/settings" exact component={Settings} />
            <Route path="/admin/temoignages" exact component={ListeTemoignages} />
            <Route path="/admin/annulations" exact component={AnnulerDemandes} />
            <Route path="/admin/demandesaccepted" exact component={ValidatedList} />
            <Route path="/admin/demandesrefused" exact component={RefusedList} />
            <Route path="/admin/images" exact component={DocumentImage} />
            <Route path="/admin/bank/createuser" exact component={UserCreate} />
            <Route path="/admin/banque/virement" exact component={AdminCredit} />
            <Route path="/admin/banque/users" exact component={AccountsDirectory} />
            <Route path="/admin/banque/transferts" exact component={AdminTransferts} />
            <Route path="/admin/banque/virementsvalides" exact component={ValidatedVirements} />
            <Route path="/admin/banque/virementsrefuses" exact component={RefusedVirements} />
            <Route path="/admin/banque/validatecardsrequests" exact component={PhysicalCardRequests} />
            <Route path="/admin/email" exact component={EnvoiEmail} />
            <Route path="/admin/logout" exact component={Logout} />
          </Switch>
        </div>
      </div>
    </>
  );
}
